import * as ae from './ae'
import * as ar from './ar'
import * as au from './au'
import * as az from './az'
import * as bh from './bh'
import * as ca from './ca'
import * as de from './de'
import * as eg from './eg'
import * as en from './en'
import * as es from './es'
import * as gb from './gb'
import * as ge from './ge'
import * as india from './in'
import * as iq from './iq'
import * as jo from './jo'
import * as kg from './kg'
import * as kw from './kw'
import * as kz from './kz'
import * as lb from './lb'
import * as ma from './ma'
import * as mx from './mx'
import * as om from './om'
import * as pk from './pk'
import * as qa from './qa'
import * as ru from './ru'
import * as sa from './sa'
import * as tj from './tj'
import * as us from './us'
import * as uz from './uz'
import * as pl from './pl'
import * as it from './it'
import * as fr from './fr'

const footerData = {
  ar,
  en,
  us,
  ae,
  sa,
  eg,
  ru,
  de,
  es,
  gb,
  ge,
  iq,
  ma,
  kw,
  bh,
  jo,
  qa,
  pk,
  in: india,
  om,
  kz,
  uz,
  tj,
  kg,
  lb,
  au,
  ca,
  mx,
  az,
  pl,
  it,
  fr,
}
export const defaultFooterLinksWithFlags = [
  {
    title: 'Uçak Bileti',
    href: 'https://www.enuygun.com/ucak-bileti/',
    items: [
      {
        title: 'THY',
        href: 'https://www.enuygun.com/ucak-bileti/thy/',
      },
      {
        title: 'Pegasus',
        href: 'https://www.enuygun.com/ucak-bileti/pegasus/',
      },
      {
        title: 'SunExpress',
        href: 'https://www.enuygun.com/ucak-bileti/sun-express/',
      },
      {
        title: 'Ajet',
        href: 'https://www.enuygun.com/ucak-bileti/ajet/',
      },
      {
        title: 'Kıbrıs Uçak Bileti',
        href: 'https://www.enuygun.com/ucak-bileti/kibris/',
      },
    ],
  },
  {
    title: 'Otel',
    href: 'https://www.enuygun.com/otel/',
    items: [
      {
        title: 'İstanbul Otelleri',
        href: 'https://www.enuygun.com/otel/bolge/istanbul-1639/',
      },
      {
        title: 'Antalya Otelleri',
        href: 'https://www.enuygun.com/otel/bolge/antalya-481/',
      },
      {
        title: 'Bodrum Otelleri',
        href: 'https://www.enuygun.com/otel/bolge/bodrum-745/',
      },
      {
        title: 'İzmir Otelleri',
        href: 'https://www.enuygun.com/otel/bolge/izmir-1665/',
      },
      {
        title: 'Marmaris Otelleri',
        href: 'https://www.enuygun.com/otel/bolge/marmaris-4302/',
      },
      {
        title: 'Fethiye Otelleri',
        href: 'https://www.enuygun.com/otel/bolge/fethiye-6341134/',
      },
      {
        title: 'Uçak + Otel Paketleri',
        href: 'https://www.enuygun.com/otel/ucakli-paketler/',
      },
    ],
  },
  {
    title: 'Otobüs Bileti',
    href: 'https://www.enuygun.com/otobus-bileti/',
    items: [
      {
        title: 'İstanbul Otobüs Bileti',
        href: 'https://www.enuygun.com/otobus-bileti/istanbul/',
      },
      {
        title: 'Ankara Otobüs Bileti',
        href: 'https://www.enuygun.com/otobus-bileti/ankara/',
      },
      {
        title: 'İzmir Otobüs Bileti',
        href: 'https://www.enuygun.com/otobus-bileti/izmir/',
      },
      {
        title: 'Bodrum Otobüs Bileti',
        href: 'https://www.enuygun.com/otobus-bileti/bodrum/',
      },
      {
        title: 'Adana Otobüs Bileti',
        href: 'https://www.enuygun.com/otobus-bileti/adana/',
      },
      {
        title: 'Antalya Otobüs Bileti',
        href: 'https://www.enuygun.com/otobus-bileti/antalya/',
      },
      {
        title: 'Otobüs Bileti Satın Alma Rehberi',
        href: 'https://www.enuygun.com/otobus-bileti/otobus-bileti-satin-alma-rehberi/',
      },
    ],
  },
  {
    title: 'Araç Kiralama',
    href: 'https://www.enuygun.com/arac-kiralama/',
    items: [
      {
        title: 'İstanbul Araç Kiralama',
        href: 'https://www.enuygun.com/arac-kiralama/sehir/istanbul/',
      },
      {
        title: 'Ankara Araç Kiralama',
        href: 'https://www.enuygun.com/arac-kiralama/sehir/ankara/',
      },
      {
        title: 'İzmir Araç Kiralama',
        href: 'https://www.enuygun.com/arac-kiralama/sehir/izmir/',
      },
      {
        title: 'Antalya Araç Kiralama',
        href: 'https://www.enuygun.com/arac-kiralama/sehir/antalya/',
      },
      {
        title: 'Aylık Araç Kiralama',
        href: 'https://www.enuygun.com/arac-kiralama/aylik-arac-kiralama/',
      },
    ],
  },
  {
    title: 'Transfer',
    href: 'https://www.enuygun.com/transfer/',
    items: [
      {
        title: 'Sabiha Gökçen',
        href: 'https://www.enuygun.com/transfer/istanbul-sabiha-gokcen-havalimani/',
      },
      {
        title: 'İstanbul Havalimanı',
        href: 'https://www.enuygun.com/transfer/istanbul-havalimani/',
      },
      {
        title: 'Antalya Havalimanı',
        href: 'https://www.enuygun.com/transfer/antalya-havalimani/',
      },
      {
        title: 'İzmir Havalimanı',
        href: 'https://www.enuygun.com/transfer/izmir-adnan-menderes-havalimani/',
      },
    ],
  },
  {
    title: 'Finans',
    href: 'https://www.enuygunfinans.com/',
    items: [
      {
        title: 'İhtiyaç Kredisi',
        href: 'https://www.enuygunfinans.com/kredi/ihtiyac/',
      },
      {
        title: 'EYT Banka Promosyonları',
        href: 'https://www.enuygunfinans.com/kredi/eyt-banka-promosyonlari/',
      },
      {
        title: 'Konut Kredisi',
        href: 'https://www.enuygunfinans.com/kredi/konut/',
      },
      {
        title: 'Taşıt Kredisi',
        href: 'https://www.enuygunfinans.com/kredi/tasit/',
      },
      {
        title: 'Kobi Kredisi',
        href: 'https://www.enuygunfinans.com/kredi/kobi/',
      },
      {
        title: 'Kredi Kartı',
        href: 'https://www.enuygunfinans.com/kredi-karti/',
      },
      {
        title: 'Mevduat',
        href: 'https://www.enuygunfinans.com/mevduat/',
      },
    ],
  },
  {
    title: 'Sigorta',
    href: 'https://www.enuygunsigorta.com/',
    rel: 'noopener noreferrer',
    target: '_blank',
    items: [
      {
        title: 'Kasko',
        href: 'https://www.enuygunsigorta.com/kasko/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      {
        title: 'Zorunlu Trafik Sigortası',
        href: 'https://www.enuygunsigorta.com/zorunlu-trafik-sigortasi/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      {
        title: 'Seyahat Sigortası',
        href: 'https://www.enuygunsigorta.com/seyahat-sigortasi/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      {
        title: 'Sağlık Sigortası',
        href: 'https://www.enuygunsigorta.com/saglik-sigortasi/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      {
        title: 'Tamamlayıcı Sağlık Sigortası',
        href: 'https://www.enuygunsigorta.com/tamamlayici-saglik-sigortasi/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      {
        title: 'Konut Sigortası',
        href: 'https://www.enuygunsigorta.com/konut-sigortasi/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
      {
        title: 'DASK',
        href: 'https://www.enuygunsigorta.com/dask/',
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Enuygun Kurumsal',
    href: 'https://www.enuygun.com/uyelik/kurumsal/',
    items: [
      {
        title: 'Seyahat Edenler için',
        href: 'https://www.enuygun.com/uyelik/kurumsal/',
      },
      {
        title: 'Seyahat Yönetenler için',
        href: 'https://www.enuygun.com/uyelik/kurumsal/kayit/',
      },
    ],
  },
  {
    title: 'Enuygun Hakkında',
    items: [
      { title: 'Hakkımızda', href: 'https://www.enuygun.com/hakkinda/' },
      { title: 'İletişim', href: 'https://www.enuygun.com/iletisim/' },
      {
        title: 'Şirket Bilgileri',
        href: 'https://www.enuygun.com/sirket-bilgileri/',
      },
      { title: 'Reklam', href: 'https://www.enuygun.com/reklam/' },
      { title: 'Kariyer', href: 'https://www.enuygun.com/kariyer/' },
      {
        title: 'Logo Kullanımı',
        href: 'https://www.enuygun.com/logo-ve-isim-kullanim-standartlari/',
      },
      {
        title: 'Ödüllerimiz',
        href: 'https://www.enuygun.com/odullerimiz/',
      },
      {
        title: 'Sürdürülebilirlik ve Sosyal Sorumluluk',
        href: 'https://www.enuygun.com/surdurulebilirlik-ve-sosyal-sorumluluk/',
      },
    ],
  },
  {
    title: 'Diğer',
    items: [
      {
        title: 'Enuygun Blog',
        href: 'https://www.enuygun.com/bilgi/',
      },
      {
        title: 'Kampanyalar',
        href: 'https://www.enuygun.com/kampanyalar/',
      },
      {
        title: 'Yardım',
        href: 'https://www.enuygun.com/yardim/',
      },
      {
        title: 'İşlem Rehberi',
        href: 'https://www.enuygun.com/islem-rehberi/',
      },
      {
        title: 'Resmi Tatiller',
        href: 'https://www.enuygun.com/resmi-tatil-gunleri/',
      },
      {
        title: 'Bilet İptal İade',
        href: 'https://www.enuygun.com/bilet-iptal-iade/',
      },
      {
        title: 'Aydınlatma Metni',
        href: 'https://www.enuygun.com/aydinlatma-metni/',
      },
      {
        title: 'Kullanım Koşulları',
        href: 'https://www.enuygun.com/kullanim-kosullari/',
      },
      {
        title: 'Gizlilik',
        href: 'https://www.enuygun.com/gizlilik/',
      },
    ],
  },
]

// Market ve language'e göre footer verilerini döndüren helper fonksiyon
export const getStaticFooterData = (market: string, language: string) => {
  // console.log(`\n🔍 [STATIC FOOTER DATA] Statik veri aranıyor: ${market}-${language}`)

  const marketData = footerData[market]
  if (!marketData) {
    console.warn(`   ❌ Market bulunamadı: ${market}`)
    // console.log(`   └─ Mevcut marketler: ${Object.keys(footerData).join(', ')}\n`)
    return null
  }

  const locale = `${market}-${language}`

  // footerLinks ve footerMoreLinks'i al
  const footerLinks = marketData.footerLinks?.[locale]
  const footerMoreLinks = marketData.footerMoreLinks?.[locale]

  if (!footerLinks && !footerMoreLinks) {
    // console.warn(`   ❌ Locale için veri bulunamadı: ${locale}`)

    // Mevcut locale'leri göster
    const availableLocales = Object.keys(marketData.footerLinks || {})
    // console.log(`   └─ Mevcut locale'ler: ${availableLocales.join(', ')}\n`)
    return null
  }

  // console.log(`   ✅ Statik veri bulundu`)
  // console.log(`   ├─ footerLinks: ${footerLinks?.length || 0} section`)
  // console.log(`   └─ footerMoreLinks: ${footerMoreLinks?.length || 0} section\n`)

  return {
    Links: footerLinks || [],
    moreLinks: footerMoreLinks || [],
  }
}

export default footerData
